/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

 import React from 'react'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
 import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
 
 import './styles.scss'
 import { TypescriptComponent } from 'components/typescriptExample'
 import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
 import { Image, Link } from '@ta-interaktiv/contentbricks'
 import { browserCheck } from '@ta-interaktiv/browsercheck'
 
 // TODO Set the correct article ID here
 const ARTICLE_ID = '00000000'
 
 export function AppComponent() {
   return (
     <div className='index'>
       <ThemeSwitch />
 
       <div className='ui one column grid stackable'>
         <div className='column'>
           <div className='introBox'>
             <h4 className='graphicTitle'>
               Long March 5
             </h4>
             {/* <div className='graphicSubtitle'>
               Das BAG empfiehlt die Selbsttests nur bei Personen ohne Symptome,
               ist also eine Teststrategie in die Breite. Gemäss{' '}
               <Link href='https://www.medrxiv.org/content/10.1101/2021.01.06.20249009v1'>
                 Studie
               </Link>{' '}
               der Charité Berlin und der Universität Heidelberg beträgt sie
               Sensitivität des Roche-Tests 83.3% und die Spezifität 99.1% bei
               symptomatischen Personen (für Asymptomatische gibt es keine
               Daten). Was dies bedeutet, zeigt folgende Grafik.
             </div> */}
           </div>
           <Image
             file={
               browserCheck.isMobile
                 ? require('../../images/long-march-5-mobile.svg')
                 : require('../../images/long-march-5.svg')
             }
             // file={require('../../images/pollenkalender.svg')}
             alt='flussdiagramm selbstests'
             className='cbImage selbsttests'
           />

           {/* <div className='foot'>
             <p className='source'>Grafik: pvo</p>
           </div> */}
         </div>
       </div>
     </div>
   )
 }
 